import { useCallback, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { setFullScreenInstance } from '@/redux/common/CommonActions';

export const useFullScreen = () => {
  const dispatch = useDispatch();
  // TODO: fix types
  // @ts-expect-error
  const fullScreenStatus = useSelector((state) => state.common.fullScreenStatus, shallowEqual);

  const handleFullScreenChange = useCallback(() => {
    dispatch(setFullScreenInstance(!fullScreenStatus));
  }, [fullScreenStatus, dispatch]);

  const toggleFullScreen = () => {
    const doc = window.document;
    const docEl = doc.documentElement;

    const requestFullScreen =
      docEl.requestFullscreen ||
      // @ts-expect-error
      docEl.mozRequestFullScreen ||
      // @ts-expect-error
      docEl.webkitRequestFullScreen ||
      // @ts-expect-error
      docEl.msRequestFullscreen;

    const cancelFullScreen =
      // @ts-expect-error
      doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

    if (
      !doc.fullscreenElement &&
      // @ts-expect-error
      !doc.mozFullScreenElement &&
      // @ts-expect-error
      !doc.webkitFullscreenElement &&
      // @ts-expect-error
      !doc.msFullscreenElement
    ) {
      requestFullScreen.call(docEl);
    } else {
      cancelFullScreen.call(doc);
    }
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullScreenChange);
    document.addEventListener('mozfullscreenchange', handleFullScreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullScreenChange);
    document.addEventListener('msfullscreenchange', handleFullScreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullScreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullScreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullScreenChange);
      document.removeEventListener('msfullscreenchange', handleFullScreenChange);
    };
  }, [handleFullScreenChange]);

  return { toggleFullScreen };
};
